import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "luvsprout_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [giftWrap, setGiftWrap] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
      setItems(raw.items || []);
      setGiftWrap(!!raw.giftWrap);
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify({ items, giftWrap }));
  }, [items, giftWrap]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) =>
          i.product_id === product.id
            ? { ...i, quantity: Math.min(i.quantity + qty, product.stock) }
            : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          image: (product.images || [])[0],
          stock: product.stock,
          quantity: Math.min(qty, product.stock),
        },
      ];
    });
    setDrawerOpen(true);
  };

  const remove = (productId) =>
    setItems((prev) => prev.filter((i) => i.product_id !== productId));

  const setQty = (productId, qty) =>
    setItems((prev) =>
      prev
        .map((i) =>
          i.product_id === productId
            ? { ...i, quantity: Math.max(1, Math.min(qty, i.stock)) }
            : i
        )
        .filter((i) => i.quantity > 0)
    );

  const clear = () => {
    setItems([]);
    setGiftWrap(false);
  };

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        items,
        add,
        remove,
        setQty,
        clear,
        count,
        subtotal,
        giftWrap,
        setGiftWrap,
        drawerOpen,
        setDrawerOpen,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
